var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 29C8.3125 29 7.72396 28.7552 7.23438 28.2656C6.74479 27.776 6.5 27.1875 6.5 26.5V11.5C6.5 10.8125 6.74479 10.224 7.23438 9.73438C7.72396 9.24479 8.3125 9 9 9H15.4688C15.8021 9 16.1198 9.0625 16.4219 9.1875C16.724 9.3125 16.9896 9.48958 17.2188 9.71875L19 11.5H29C29.6875 11.5 30.276 11.7448 30.7656 12.2344C31.2552 12.724 31.5 13.3125 31.5 14V26.5C31.5 27.1875 31.2552 27.776 30.7656 28.2656C30.276 28.7552 29.6875 29 29 29H9ZM21.5 21.5V22.75C21.5 23.1042 21.6198 23.401 21.8594 23.6406C22.099 23.8802 22.3958 24 22.75 24C23.1042 24 23.401 23.8802 23.6406 23.6406C23.8802 23.401 24 23.1042 24 22.75V21.5H25.25C25.6042 21.5 25.901 21.3802 26.1406 21.1406C26.3802 20.901 26.5 20.6042 26.5 20.25C26.5 19.8958 26.3802 19.599 26.1406 19.3594C25.901 19.1198 25.6042 19 25.25 19H24V17.75C24 17.3958 23.8802 17.099 23.6406 16.8594C23.401 16.6198 23.1042 16.5 22.75 16.5C22.3958 16.5 22.099 16.6198 21.8594 16.8594C21.6198 17.099 21.5 17.3958 21.5 17.75V19H20.25C19.8958 19 19.599 19.1198 19.3594 19.3594C19.1198 19.599 19 19.8958 19 20.25C19 20.6042 19.1198 20.901 19.3594 21.1406C19.599 21.3802 19.8958 21.5 20.25 21.5H21.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketBlack);
export default __webpack_public_path__ + "static/media/ticket_black.e82d5012bbbca34af73c3e12d55e927f.svg";
export { ForwardRef as ReactComponent };